import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { ToolbarNotificationsDropdownComponent } from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { NotificationsService } from './toolbar-notifications-dropdown/services/notifications.service';
import { LocalStorageDataService } from 'src/app/pages/pages/auth/services/local-storage-data.service';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'vex-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonModule, MatIconModule, CommonModule]
})
export class ToolbarNotificationsComponent implements OnInit, OnDestroy {
  @ViewChild('originRef', { static: true, read: ElementRef })
  originRef?: ElementRef;

  dropdownOpen: boolean = false;
  hayNotificacionesSinLeer: boolean = false;
  private subscription: Subscription = new Subscription();
  private usuarioActual: any = null;

  // Intervalo en milisegundos para verificar nuevas notificaciones (cada 30 segundos)
  private readonly POLLING_INTERVAL = 10000;

  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private notificationsService: NotificationsService,
    private localStorageDataService: LocalStorageDataService
  ) {}

  ngOnInit() {
    this.usuarioActual = this.localStorageDataService.getData('user');

    // Suscribirse al estado de notificaciones sin leer
    this.subscription.add(
      this.notificationsService.notificacionesSinLeer$.subscribe(tieneSinLeer => {
        this.hayNotificacionesSinLeer = tieneSinLeer;
        this.cd.markForCheck();
      })
    );

    // Verificar notificaciones sin leer al iniciar
    this.verificarNotificacionesSinLeer();

    // Configurar verificación periódica de nuevas notificaciones
    if (this.usuarioActual?.id_ciud) {
      this.subscription.add(
        interval(this.POLLING_INTERVAL).subscribe(() => {
          this.verificarNotificacionesSinLeer();
        })
      );
    }
  }

  ngOnDestroy() {
    // Desuscribirse para evitar memory leaks
    this.subscription.unsubscribe();
  }

  verificarNotificacionesSinLeer() {
    if (this.usuarioActual?.id_ciud) {
      this.notificationsService.verificarNotificacionesSinLeer(this.usuarioActual.id_ciud);
    }
  }

  showPopover() {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    if (!this.originRef) {
      throw new Error('originRef undefined!');
    }

    const popoverRef = this.popover.open({
      content: ToolbarNotificationsDropdownComponent,
      origin: this.originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      // Re-verificar notificaciones después de cerrar el popover
      this.verificarNotificacionesSinLeer();
      this.cd.markForCheck();
    });
  }
}
